import image1 from "../Sponsors/Sponsorimages/Logo-6.png";
import image2 from "../Sponsors/Sponsorimages/Logo-7.png";
import image3 from "../Sponsors/Sponsorimages/Logo-9.png";
import image4 from "../Sponsors/Sponsorimages/logo3.png";
import image5 from "../Sponsors/Sponsorimages/logo5.png";
import image6 from "../Sponsors/Sponsorimages/logo8.png";
import image7 from "../Sponsors/Sponsorimages/logo9.png";
export const SponsorsData = [
  {
    image: image1,
  },
  { image: image2 },
  { image: image3 },
  { image: image4 },
  { image: image5 },
  { image: image6 },
  { image: image7 },
];
